module.exports = __webpack_public_path__ + "static/mevia-extraimg2@2x-min-3ff8c5dfc21daa60e266862718481f45.png";